import src from "IMAGE";
export default { src, width: 236, height: 55, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AEkwCEYUDQIUJhkEJSMXBCQiFgQiHBIDHCQYBCUgFQQgADAgBTAeEwMfNSIGNzEgBjMsHQUxKhsFLTMiBjcsHQUt5B4HK5oW4ZsAAAAASUVORK5CYII="};
